require('./style.scss');

export default class Loading {
    _class = 'loading';
    _node = null;

    constructor(wrapper, customClassName='') {
        this._wrapper = wrapper;
        this._create(customClassName);
    }

    _create(customClassName){
        const div = document.createElement('div');
        div.classList.add(this._class);
        div.classList.add('loading-block');
        div.classList.add(customClassName);

        this._node = div;
    }

    show(){
        if(!this._wrapper.contains(this._node)) this._wrapper.appendChild(this._node);
    }

    hide(){
        if(this._wrapper.contains(this._node)) this._wrapper.removeChild(this._node);
    }

    applyClass(className){
        this._node.classList.add(className);
    }

    destroy(){
        if(this._node && this._node.parentNode === this._wrapper) this._wrapper.removeChild(this._node);
    }
}
